import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midday = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#000000',
    pageBackground: '#F6F6F6',
    secondaryFont: '#DDD8FF',
  },
  fonts: {
    ...templateThemeTokens.fonts,
    accent: THEME_DEFAULT_FONTS.tokyo.midday.accent
      ? THEME_DEFAULT_FONTS.tokyo.midday.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.tokyo.midday.body.value,
    heading: THEME_DEFAULT_FONTS.tokyo.midday.headline.value,
  },
});
